module.exports = {
  ...require('react-dom'),
  ...require('react-dom/client'),
}
